import {
  Component,
  HostListener,
  ViewChild,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
} from "@angular/core";
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from "@angular/material/dialog";
import { faEdit, faTrash, faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import {
  faCircleDashed,
  faPlus,
  faGripDotsVertical,
} from "@fortawesome/pro-light-svg-icons";
import { WidgetDialogComponent } from "../dialogs/widget/widget.component";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { CanvasService } from "@services/canvas.service";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { Subscription, Observable } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

class HeightAndWidth {
  height: number = 0;
  width: number = 0;
}
@Component({
    selector: "app-widget-bar",
    templateUrl: "./widget-bar.component.html",
    styleUrls: ["./widget-bar.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class WidgetBarComponent implements OnInit, OnChanges {
  constructor(
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    public parentF: FormGroupDirective,
    private canvasService: CanvasService
  ) {}
  @Input() hasEdit?: any;
  @Input() customLinks!: any;
  @Input() canvasMode: any;

  @ViewChild("widgetBar") widgetBar!: ElementRef;

  faEdit = faEdit;
  faTrash = faTrash;
  faCaretDown = faCaretDown;
  faCircleDashed = faCircleDashed;
  faPlus = faPlus;
  faQuestionCircle = faQuestionCircle;
  faGripDotsVertical = faGripDotsVertical;
  public workflows: any;
  public internals: any;
  public records: any;
  public widgetForm!: UntypedFormGroup;
  public widgetItems: any;
  savedData!: any[];
  childForm: any;
  public height: number = 0;
  public width: number = 0;
  //new widget
  openWidgetDialog(): void {
    const dialogRef = this.dialog.open(WidgetDialogComponent, {
      width: "75%",
      disableClose: true,
      data: {
        workflows: this.workflows,
        records: this.records,
        internals: this.internals,
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.addItem(result.items, result.form);
      }
    });
  }

  //edit widget
  openDetailDialog(fields: any, idx: number): void {
    const dialogRef = this.dialog.open(WidgetDialogComponent, {
      width: "75%",
      disableClose: true,
      data: {
        buttonTitle: fields.get("buttonTitle").value,
        link: fields.get("link").value,
        linkType: fields.get("linkType").value,
        recordId: fields.get("recordId").value,
        datasetId: fields.get("datasetId").value,
        workflowId: fields.get("workflowId").value,
        internalId: fields.get("internalId").value,
        description: fields.get("description").value,
        itemArray: fields.get("itemArray").value.reverse(),
        workflows: this.workflows,
        internals: this.internals,
        records: this.records,
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let items = this.widgetForm.get("items") as UntypedFormArray;
        items.removeAt(idx);
        this.addItem(result.items, result.form);
        const from = items.length - 1;
        const to = idx;
        this.moveItemInFormArray(items, from, to);
      } else {
        fields.get("itemArray").value.reverse();
      }
    });
  }
  openmenu(item: any) {
    this.widgetItems = item.value.itemArray;
  }
  get widgetControls() {
    return this.widgetForm.get("items") as UntypedFormArray;
  }

  get widgetLength() {
    let items = this.widgetForm.get("items") as UntypedFormArray;
    let number = items.get("itemArray") as UntypedFormArray;
    return number.length;
  }

  showWidgetBar() {
    if (!this.hasEdit) {
      return true;
    }

    if (
      this.workflows &&
      this.internals &&
      this.records &&
      this.workflows.length > 0 &&
      this.internals.length > 0 &&
      this.records.length > 0
    ) {
      if (this.hasEdit) {
        return true;
      } else {
        let items = this.widgetForm.get("items") as UntypedFormArray;
        if (items.length <= 0) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  createItem(fields: any, itemArray: any, form: any): UntypedFormGroup {
    let buttonTitle;

    if (form.get) {
      buttonTitle = form.get("buttonTitle")?.value;
    } else {
      buttonTitle = [form.buttonTitle];
    }

    return this.fb.group({
      buttonTitle: buttonTitle || "",
      title: [fields.title],
      link: [fields.link],
      linkType: [fields.linkType],
      recordId: [fields.recordId],
      datasetId: [fields.datasetId],
      workflowId: [fields.workflowId],
      internalId: [fields.internalId],
      description: [fields.description],
      itemArray: this.fb.array(itemArray),
    });
  }

  addItem(itemArray: any, form: any): void {
    let savedItems = itemArray;
    if (this.widgetForm) {
      let items = this.widgetForm.get("items") as UntypedFormArray;
      if (itemArray && itemArray.length > 0) {
        itemArray = itemArray.slice(0, 1);
        itemArray.forEach((fields: any) => {
          items.push(this.createItem(fields, savedItems, form));
        });
      }
      this.buildAndSaveArray();
    }
  }

  buildAndSaveArray() {
    let items = this.widgetForm.get("items") as UntypedFormArray;

    this.childForm.get("customLinks")!.setValue(items);
  }
  deleteItem(idx: number) {
    if (event) {
      event.stopPropagation();
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: "Remove this widget?",
          actionButton: "remove",
        },
        panelClass: ["canvas-dialog"],
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          let items = this.widgetForm.get("items") as UntypedFormArray;
          items.removeAt(idx);
          this.buildAndSaveArray();
        }
      });
    }
  }

  gotoLink(item: any) {
    let link: string | undefined;
    const platformUrl = sessionStorage.getItem("platformUrl");

    if (item.linkType === "Platform") {
      link = platformUrl + "/" + item.link;
    } else if (item.linkType === "Workflow") {
      link =
        platformUrl +
        "/index.php?module=qv_wf&mode=display&wf_id=" +
        item.workflowId;
    } else if (item.linkType === "Internal") {
      link = platformUrl + "/index.php?" + item.internalId;
    } else if (item.linkType === "Report") {
      this.canvasService.getCanvas(item.recordId).subscribe(
        (success: any) => {
          link = "/reports/view/" + item.recordId;
          this.openLink(link);
        },
        (error: HttpErrorResponse) => {
          if (error.error && error.error.reportNotFound === undefined) {
            error.error.reportNotFound = true;
          }
        }
      );
    } else if (item.linkType === "Direct") {
      link = item.link;
    }

    if (link) {
      let result = link.substring(0, 6);
      this.openLink(link, result);
    }
  }
  
  openLink(link: string, result: string | undefined = undefined) {
    if (!result) {
      result = link.substring(0, 6);
    }

    if (result === "mailto") {
      window.open(link, "_self");
    } else {
      window.open(link, "_blank");
      window.focus();
    }
  }

  get items() {
    return this.widgetForm.get("items") as UntypedFormArray;
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex != event.currentIndex) {
      let formArray = this.widgetForm.get("items") as UntypedFormArray;
      const from = event.previousIndex;
      const to = event.currentIndex;
      this.moveItemInFormArray(formArray, from, to);

      this.childForm.get("customLinks")!.setValue(formArray);
    }
  }

  moveItemInFormArray(
    formArray: UntypedFormArray,
    fromIndex: number,
    toIndex: number
  ): void {
    const dir = toIndex > fromIndex ? 1 : -1;
    const from = fromIndex;
    const to = toIndex;
    const temp = formArray.at(from);
    for (let i = from; i * dir < to * dir; i = i + dir) {
      const current = formArray.at(i + dir);
      formArray.setControl(i, current);
    }
    formArray.setControl(to, temp);
  }
  getCanvasWorkflows() {
    this.canvasService.getCanvasWorkflows().subscribe((data: any) => {
      let groupName = "";
      let workflows: any[] = [];

      data.data.forEach((group: any) => {
        groupName = group.name;
        group.links.data.forEach((item: any) => {
          const workflowid = item.value.split("wf_id=");
          item.value = workflowid[1];
          item.group = groupName;
          workflows.push(item);
        });
      });
      this.workflows = workflows;
    });
  }

  getCanvasInternals(): void {
    const internals: any[] = [];
    this.canvasService.getCanvasInternals().subscribe((data: any) => {
      data.data.forEach((pageType: any) => {
        pageType.links.data.forEach((link: any) => {
          link.group = pageType.name;
          internals.push(link);
        });
      });
      this.internals = internals;
    });
  }

  getCanvasReports() {
    this.canvasService.getCanvasReports().subscribe((data: any) => {
      this.records = data.data;
    });
  }
  initForm() {
    this.widgetForm = this.fb.group({
      items: this.fb.array([]),
    });
    let linkArray: any = [];
    if (this.childForm) {
      this.customLinks = this.childForm.get("customLinks")!.value;
    }
    if (this.customLinks && this.customLinks.value) {
      linkArray = this.customLinks.value;
    } else {
      linkArray = this.customLinks;
    }

    if (linkArray && this.widgetForm) {
      linkArray.forEach((item: any) => {
        item.itemArray.forEach((linkitem: any) => {
          if (linkitem.linkType == "Workflow") {
            linkitem.workflowId = linkitem.workflowId.toString();
            const workflowid = linkitem.workflowId.split("wf_id=");
            if (workflowid.length > 1) linkitem.workflowId = workflowid[1];
          }
        });
        this.addItem(item.itemArray, item);
      });
    }
  }
  private subscription!: Subscription;

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.doDivHeightChange(this.getHeightAndWidthObject());
  }

  getHeightAndWidthObject(): HeightAndWidth {
    const newValues = new HeightAndWidth();
    newValues.height = this.widgetBar.nativeElement.offsetHeight;
    newValues.width = this.widgetBar.nativeElement.offsetWidth;
    return newValues;
  }
  setupHeightMutationObserver() {
    const observerable$ = new Observable<HeightAndWidth>((observer) => {
      // Callback function to execute when mutations are observed
      // this can and will be called very often
      const callback = (mutationsList: any, observer2: any) => {
        observer.next(this.getHeightAndWidthObject());
      };
      // Create an observer instance linked to the callback function
      const elementObserver = new MutationObserver(callback);

      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };
      // Start observing the target node for configured mutations
      elementObserver.observe(this.widgetBar.nativeElement, config);
    });

    this.subscription = observerable$
      .pipe(
        debounceTime(50), //wait until 50 milliseconds have lapsed since the observable was last sent
        distinctUntilChanged() //if the value hasn't changed, don't continue
      )
      .subscribe((newValues) => {
        this.doDivHeightChange(newValues);
      });
  }

  doDivHeightChange(newValues: HeightAndWidth) {
    this.height = newValues.height;
    this.width = newValues.width;
  }

  ngAfterViewInit() {
    this.setupHeightMutationObserver();
    this.doDivHeightChange(this.getHeightAndWidthObject());
  }
  ngOnChanges() {
    this.childForm = this.parentF.form;
    if (this.hasEdit) {
      if (!this.workflows) this.getCanvasWorkflows();
      if (!this.internals) this.getCanvasInternals();
      if (!this.records) this.getCanvasReports();
    }
    this.initForm();
  }
  ngOnInit() {
    this.childForm = this.parentF.form;

    this.initForm();
  }
}
